import { useMemo } from "react";
import { JobPhotoReport } from "~/ui/components/jobPhotoReport";
import { getJobPhotos } from "~/shared/utils";

/**
 * Before/after (and no-export) photo carousels for a waste-export list card.
 *
 * The list rows already carry the full Job — including `file_reports` — so this
 * needs no extra request. Missing before/after photos render as placeholder
 * slots, so a card without a photo report reads as "not uploaded" rather than
 * silently showing nothing.
 */
export const WasteExportCardPhotos = ({ job }: { job: any }) => {
  const { beforePhotos, afterPhotos, failureReasonPhotos } = useMemo(
    () => getJobPhotos(job),
    [job],
  );

  return (
    <JobPhotoReport
      className="lg:flex hidden w-[400px] border-l flex-row gap-4 p-4"
      showCarouselTitles={false}
      beforePhotos={beforePhotos}
      afterPhotos={afterPhotos}
      failureReasonPhotos={failureReasonPhotos}
    />
  );
};
